/** Mobile: full-width single column. Desktop (≥lg): fixed 240px flex items. */
export const CARD_CLASS_GRID = 'h-auto max-lg:w-full flex-1 p-0 lg:max-w-[240px] lg:min-w-[240px]'

/** Mobile: full-width, no flex grow. Desktop (≥lg): fixed 240px flex items. */
export const CARD_CLASS_GRID_STRICT =
  'h-auto max-lg:w-full max-lg:flex-none lg:flex-1 p-0 lg:max-w-[240px] lg:min-w-[240px]'

/** Mobile: full-width, no flex grow. Desktop (≥lg): fixed 200px (trending cards). */
export const CARD_CLASS_GRID_SM =
  'h-auto max-lg:w-full max-lg:flex-none lg:flex-1 p-0 lg:max-w-[200px] lg:min-w-[200px]'

/** Swimlane cards (horizontal scroll). Fixed width at all breakpoints. */
export const CARD_CLASS_SWIMLANE = 'h-auto min-w-[320px] max-w-[320px] flex-none'

export const CARD_CLASS_CONTINUE_PLAYING = 'h-auto w-55 min-w-55 max-w-55 flex-none p-0'

/** SEO-only advertised src width bound for world-card thumbnails. */
export const WORLD_CARD_ADVERTISED_SRC_WIDTH = 384

/** Search results cards. Fixed 171px on mobile, 222px on desktop (≥lg). */
export const CARD_CLASS_SEARCH =
  'h-auto min-w-[171px] max-w-[171px] flex-1 p-0 lg:min-w-[222px] lg:max-w-[222px]'

/** Explore grid container. Single column on mobile, auto-fill on desktop. */
export const CARD_GRID_AUTO =
  'grid grid-cols-1 gap-4 md:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] md:gap-6 1.5xl:grid-cols-[repeat(auto-fill,minmax(240px,1fr))]'

/** Link props that open a card link in a new tab, such as inside a third-party iframe. */
export const NEW_TAB_LINK_PROPS = { target: '_blank', rel: 'noopener noreferrer' } as const
